// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UseShouldShowPropertyDetails_propertyV5_graphql = require("../../../__generated__/UseShouldShowPropertyDetails_propertyV5_graphql.bs.js");

var convertFragment = UseShouldShowPropertyDetails_propertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, UseShouldShowPropertyDetails_propertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(UseShouldShowPropertyDetails_propertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, UseShouldShowPropertyDetails_propertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(UseShouldShowPropertyDetails_propertyV5_graphql.node, convertFragment, fRef);
}

var PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function use$1(property) {
  var property$1 = use(property);
  var agentId;
  switch (property$1.__typename) {
    case "ForSalePropertyV5" :
        var match = property$1.agentV2Id;
        if (match !== undefined && match.__typename === "VisibleForSalePropertyAgent") {
          var match$1 = match.agent;
          agentId = match$1 !== undefined ? match$1.id : undefined;
        } else {
          agentId = undefined;
        }
        break;
    case "RentalPropertyV5" :
        var match$2 = property$1.agentId;
        agentId = match$2 !== undefined ? match$2.id : undefined;
        break;
    case "__unselected" :
        agentId = undefined;
        break;
    
  }
  return UserSession.useShouldShowPropertyDetails(agentId);
}

exports.PropertyFragment = PropertyFragment;
exports.use = use$1;
/* UserSession Not a pure module */
